export default "__VITE_ASSET__B0gEI$6S__"